<script>
  import {RouterView} from "vue-router"
  import NavBar from "@/components/2025/Nav/NavBar.vue";
  import HeroBanner from "@/components/2025/HeroBanner.vue";
  import StreamComp from "@/components/Stream/StreamComp.vue";
  import BracketViewer from "@/components/2025/Brackets/BracketViewer.vue";
  import DiscordContact from "@/components/2025/Footer/DiscordContact.vue";
  import MGEFooter from "@/components/2025/Footer/MGEFooter.vue";
  import FaqList from "@/components/FAQ/FaqList.vue";
  import SectionTitle from "@/components/2025/SectionTitle/SectionTitle.vue";
  import MediaLibrary from "@/components/2025/MediaLib/MediaLib2.vue";
  import LgameParticipatePopUp from "@/components/LgameParticipatePopUp.vue";
  import ChampionsList from "@/components/2025/Champions/ChampionsList.vue";
  export default {
    components: {
      ChampionsList,
      LgameParticipatePopUp,
      MediaLibrary,
      SectionTitle,
      HeroBanner,
      NavBar,
      RouterView,
      StreamComp,
      BracketViewer,
      DiscordContact,
      MGEFooter,
      FaqList,
    },
    data(){
      return {
        showPopUp: false,
        popUpOptions: {
          type: '',
          title: '',
          message: '',
        },
      }
    },
    async created(){
      await this.$store.dispatch('subTournaments/initTournaments');
    },
    async mounted(){
      await this.$store.dispatch('subTournaments/initTournaments');
    }
  };
</script>
<template>
  <div class="wrapper-layout m-0 p-0 w-100">
    <!-- Navbar & hero section  -->
    <NavBar/>
    <div class="">
      <HeroBanner/>
    </div>
    <div>
      <RouterView/>
    </div>
    <div class="bracket container my-5 pt-5">
      <SectionTitle subtitle="Brackets" title="Tournaments results" anchor="bracket"/>
      <BracketViewer :has-header="$route.name === 'home'" /><!-- $route.name === 'home' -->
    </div>
    <div class="stream container my-5 pt-5">
      <SectionTitle subtitle="Stream" title="LIVE streaming" anchor="stream"/>
      <StreamComp />
    </div>
    <div class="tournaments-section container my-5 pt-5" v-if="$route.name === 'home'">
      <SectionTitle subtitle="MGE 2024" title="Champions of the Previous Edition "/>
      <ChampionsList/>
    </div>
    <div class="media-library container my-5 pt-5" v-if="$route.name === 'home' && false">
      <SectionTitle subtitle="MGE 2024" title="Media library"/>
      <MediaLibrary />
    </div>
    <div>
      <div class="container my-5 pt-5">
        <SectionTitle subtitle="FAQ" title="LET's answer<br>some questions" anchor="bracket"/>
        <FaqList :dark-mode="true" key-faq="faq25" />
      </div>
      <div class="container my-5">
        <DiscordContact />
      </div>
      <div class="w-100 mt-5 pt-5">
        <MGEFooter />
      </div>
    </div>

  </div>
</template>
<style scoped>
  .wrapper-layout {
    position: relative;
    /*height: 100%;
    width: 100%;*/
    background: var(--bg-color);
    padding-top: 10px;
  }
</style>